<template>
    <!-- <section class="section-hero section-shaped my-0"  -->
    <section class="sectionBackGround">
        <div class="container shape-container d-flex align-items-center">
            <div class="col px-0">
                <div class="row justify-content-left align-items-center" style="margin-top:10%;margin-left:7%">
                    <div class="col-lg-7 text-left pt-lg">
                        <div class="row justify-content-between align-items-center mb-3 mb-sm-0">
                            <h1 class="text-white" style="
                                    font-family: ‘Noto Sans S Chinese’;
                                    font-size: 40px;
                                    font-style: normal;
                                    font-weight: 800;
                                    line-height: 58px;
                                    letter-spacing: 1px;">
                                Hi，这里是AnthorMindXX<br/>
                                一个关于健康饮食的个人网站。</h1>
                            <p class="text-white" style="
                                    font-family: 'Noto Sans S Chinese';
                                    font-size: 16px;
                                    font-style: normal;
                                    font-weight: 400;
                                    line-height: 25px;
                                    letter-spacing: 1px;">
                                目前小范围内测中，还未对外开放，<br/>
                                更多信息可以在个人微博主页了解。微博 ID：AnthroMindXX。</p>
                        </div>
                         
                        <div class="row" style="margin-top: 60px;">
                            <div class="col-sm-4" v-if="!isLoggedIn">
                                <base-button  style="
                                color: #FFF;
                                border-radius: 8px;
                                border: 1px solid #FFF;
                                font-weight: 100px;
                                height: 50px;"
                                        tag="a"
                                        href="#/login"
                                        outline block 
                                        size="lg"
                                        type="primary">
                                        登录
                                    </base-button>
                            </div>
                            <div class="col-sm-4">
                                <base-button 
                                        tag="a"
                                        style="
                                        border-radius: 8px;
                                        background: rgba(15, 245, 200, 0.90);"
                                         href="#/AboutUs"
                                         type="success" 
                                         size="lg"
                                         block>
                                        了解更多
                                </base-button>
                            </div>
                        </div>

                        <div class="row justify-content-between align-items-center mb-3 mb-sm-0" v-if="!isLoggedIn">
                            <a href="#/register" class="text-light">
                                <p class="text-white" style="
                                    margin-top: 20px;
                                    font-family: 'Noto Sans S Chinese';
                                    font-size: 16px;
                                    font-style: normal;
                                    font-weight: 400;
                                    line-height: 25px;
                                    letter-spacing: 1px;">
                                没有账户？去注册</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>
<script>
import axios from 'axios';

export default {
  data() {
    return {
        isLoggedIn: false, // Initialize to false
        searchQuery: '' // Added searchQuery
    };
  },

  created() {
    const token = this.getCookie('token');
    if(token){
      this.verifyToken(token);
    }
  },
  methods: {
         // 获取cookie中的token
      getCookie(name) {
          const value = `; ${document.cookie}`;
          const parts = value.split(`; ${name}=`);
          if (parts.length === 2) return parts.pop().split(';').shift();
      },
        async searchDocuments() {
            const token = this.getCookie('token');  // 获取token

            if (!token) {
               // alert('Token not found, please login');
                this.$router.push('/login');
                return;
            }

            if (this.searchQuery.trim() === '') {
                alert('请输入关键词');
                return;
            }

            this.$router.push('/DocQueryList?searchQuery=' + this.searchQuery);
        },
        async verifyToken(token) {
          try {
              // 使用 URL 编码格式发送数据
              const params = new URLSearchParams();
              params.append('keywords', this.searchQuery);
              params.append('token', token);
              params.append('page', 1); // 传递当前页码
              params.append('itemsPerPage', 10); // 传递每页条目数
              params.append('token', token);

              const response = await axios.post('https://anthromindxx.com/ca.php?action=verifyToken', params, {
                  headers: {
                      'Content-Type': 'application/x-www-form-urlencoded'
                  }
              });

             if (response.data.success) {
                  const { status, timeover } = response.data;
                  const parsedStatus = parseInt(status, 10);
                  const parsedTimeover = parseInt(timeover, 10);

                    if (parsedTimeover === 1 && (parsedStatus === 1 || parsedStatus === 3)) {
                      this.isLoggedIn = true; // Set to true on successful verification
                    } else {
                        this.isLoggedIn = false; // Set to false if it fails.
                    }
                  } else {
                       //console.error('Token verification failed:', response.data.message || 'Token validation failed');
                        this.isLoggedIn = false; // Set to false if it fails.
                     }
          } catch (error) {
             //console.error('Token verification request failed:', error);
              this.isLoggedIn = false; // Set to false on error
          }
      },
  },
};
</script>
<style scoped>
.sectionBackGround {
    min-height: calc(100vh - 48px); /* 确保内容区域至少与视口高度减去头部高度一样大 */
    background-image: url('https://anthromindxx.com/ant/bj.jpeg'); /* 设置背景图路径 */
    background-position: center center; /* 背景图片位置 */
    background-attachment: fixed; /* 背景图片相对于视口固定 */
    background-size: 100% 100%; /* 背景图片根据元素大小缩放 */
    overflow-y: auto; /* 在内容较多时显示滚动条 */
}
/* 确保导航栏和文字部分都使用相同的容器宽度和左边距 */
.container {
    max-width: 1200px; /* 根据实际情况设置宽度 */
    padding-left: 30px; /* 设置与 logo 对齐的左边距 */
    padding-right: 30px;
}

/* 文字部分的调整 */
.col-lg-7 {
    margin-left: 1px; /* 通过设置相同的左边距，确保文字和 logo 对齐 */
}
</style>